import React, { useRef, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/hemmexus.png";
import avatarVideo from "../../assets/avatares/avatar-santiago-scn4.webm";
import avatarVideoMp4 from "../../assets/avatares/avatar-santiago-scn4.mp4";
import manuelVideo from "../../assets/avatares/juan-hospital.webm";
import manuelVideoMp4 from "../../assets/avatares/juan-hospital.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import NextButton from "../../components/NextButton";
import avatarDummy from "../../assets/avatares/avatar-dummy.png";

import img1 from "../../assets/tests/scn3/img1-sc4-intro.png";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario4Intro({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const [canOpenDialog, setCanOpenDialog] = useState(false);

	const transcription = "Me dices que este tratamiento es diferente… y eso me da algo de esperanza.<br/>Saber que no tengo que estar ingresado todo el tiempo y que se puede llevar de forma más continua… la verdad es que me ayuda a pensar que podré seguir con mi vida.<br/>Después de todo lo que he pasado, no espero milagros… pero sí una oportunidad de que esto funcione y me dé un poco de estabilidad."

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 0.8, "blue", true);
	};

	const handleContinue = () => {
		navigate(ROUTES.SCENARIO4_CONTEXT1);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	useEffect(() => {
		const timer = setTimeout(() => setCanOpenDialog(true), 25000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-end h-100 px-4 pb-4">
						<video
							ref={videoRef}
							className="mb-4 pb-5"
							autoPlay
							playsInline
							preload="auto"
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur-blue h-100 px-5 pt-5">
						<div className="row recuadro-white recuadro-border-blue txtTexto1 mb-3 w-100">
							<p className="txtTexto1 black mb-4">
								Doctor, me he realizado los estudios que me han solicitado ¿Ya tienen un diágnóstico claro?
							</p>
						</div>
						<div className="mt-2 d-flex align-items-center justify-content-end w-100">
						{/* Botón siguiente */}
						<NextButton
							navigateTo={ROUTES.SCENARIO4_CONTEXT1}
							activeScenario={activeScenario}
							color="blue"
							textColor="white"
						/>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario4Intro);
